<template>
  <div class="login-information">
    <div class="tip">显示最近15天的登录记录</div>
    <el-table :data="showData" style="width: 100%;margin-bottom:30px;">
      <el-table-column prop="c_t" label="登录时间"></el-table-column>
      <el-table-column prop="type" label="登录设备"></el-table-column>
      <el-table-column prop="ip" label="登录IP"></el-table-column>
    </el-table>
    <el-pagination
      style="float:right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10]"
      :page-size="100"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'add',
  data () {
    return {
      tableData: [],
      showData: [],
      currentPage:1,
      pageSize:5,
      total:0
    }
  },
  methods: {
    getData() {
      _api.personal.loginLog().then(res=>{
        this.tableData = res.data
        this.total = res.data.length
        this.showData = JSON.parse(JSON.stringify(this.tableData))
        this.handleSizeChange(this.pageSize)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      let start = (this.currentPage-1) * this.pageSize
      this.showData = JSON.parse(JSON.stringify(this.tableData))
      this.showData = this.showData.splice(start,this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let start = (this.currentPage-1) * this.pageSize
      this.showData = JSON.parse(JSON.stringify(this.tableData))
      this.showData = this.showData.splice(start,this.pageSize)
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss">
.login-information {
  margin: 0 22px;
  .tip {
    margin: 10px 0 30px;
  }
  .cell {
    font-size: 14px;
    color: #585f60;
    text-align: center;
  }

  th {
    background-color: #ebeced !important;
  }
}
</style>
